var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('br'),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xs":20,"sm":18,"md":14,"lg":8}},[_c('loginForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }